import { render } from "./rectangle_item.vue?vue&type=template&id=9275bf2c&scoped=true"
import script from "./rectangle_item.vue?vue&type=script&lang=js"
export * from "./rectangle_item.vue?vue&type=script&lang=js"

import "./rectangle_item.vue?vue&type=style&index=0&id=9275bf2c&scoped=true&lang=css"

import exportComponent from "/home/kabull/js/vue/iqtest/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9275bf2c"]])

export default __exports__